import DivChip from "./DivChip";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

import zahravi from "./assets/zahravi.png";
import ghazi from "./assets/ghazi.png";
import tatao from "./assets/tatao.png";
import pegah from "./assets/pegah.png";
import dezmaye from "./assets/Dezmaye.png";
import uniliver from "./assets/uniliver.png";
import kosar from "./assets/kosar.png";
import ady from "./assets/ady.png";
import polynar from "./assets/polynar.png";
import phaema1 from "./assets/flometr.png";

const Field = () => {
  return (
    <>
      <DivChip text="Fields of Proficiency "></DivChip>
      <Box sx={{ m: 3, p: 5 }}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ fontFamily: "roboto" }}
          >
            Food & Beverage
          </AccordionSummary>
          <AccordionDetails>
            <Grid container>
              <Grid xs={12} sm={6} md={4} lg={4} xl={4}>
                <Card sx={{ maxWidth: 345, m: 1 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image={tatao}
                      alt="TATAO Pic"
                    />
                    <CardContent>
                      <Typography variant="body1">
                        Reconstruction of power & upgrading of control system to
                        PLC & HMI (SIEMENS CPU-314C/TIA) Schmidt evaporator
                        <Typography>TATAO (URMIA-IRAN)</Typography>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              <Grid xs={12} sm={6} md={4} lg={4} xl={4}>
                <Card sx={{ maxWidth: 345, m: 1 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image={pegah}
                      alt="PEGAH pic"
                    />
                    <CardContent>
                      <Typography variant="body1">
                        Monitoring ,Reporting & Data logging system MF & UHT
                        plant (SIEMENS S7-300/PSC7)
                        <Typography>
                          Pegah Azarbaijan-Diary (TABRIZ-IRAN)
                        </Typography>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              <Grid xs={12} sm={6} md={4} lg={4} xl={4}>
                <Card sx={{ maxWidth: 345, m: 1 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image={dezmaye}
                      alt="DEZMAYE pic"
                    />
                    <CardContent>
                      <Typography variant="body1">
                        Upgrading of Control & Monitoring system. of yeast
                        plant, to PLC & HMI (SIEMENS CPU-414/PCS7 )
                        <Typography>
                          Kermanshah yeast Company-Bartarmaye (KERMANSHAH-IRAN)
                        </Typography>
                        <Typography>
                          Khuzestan yeast Company -Dezmaye (DEZFUL-IRAN)
                        </Typography>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ fontFamily: "roboto" }}
          >
            Pharmaceutical
          </AccordionSummary>
          <AccordionDetails>
            <Grid container>
              <Grid xs={12} sm={6} md={4} lg={4} xl={4}>
                <Card sx={{ maxWidth: 345, m: 1 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image={phaema1}
                      alt="DEZMAYE pic"
                    />
                    <CardContent>
                      <Typography variant="body1">
                        Flow Measurement & Batching Control of water
                        purification & Resolvent plant (E+H promass-83F+Flow
                        Computer)
                        <Typography>Ghazi Pharma.Co.(TABRIZ-IRAN)</Typography>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              <Grid xs={12} sm={6} md={4} lg={4} xl={4}>
                <Card sx={{ maxWidth: 345, m: 1 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image={zahravi}
                      alt="DEZMAYE pic"
                    />
                    <CardContent>
                      <Typography variant="body1">
                        Monitoring ,Reporting & Data logging (DP-RH%-T) of
                        warehouses & Product line
                        <Typography>Zahravi Pharma.Co.(TABRIZ-IRAN)</Typography>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              <Grid xs={12} sm={6} md={4} lg={4} xl={4}>
                <Card sx={{ maxWidth: 345, m: 1 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image={ghazi}
                      alt="DEZMAYE pic"
                    />
                    <CardContent>
                      <Typography variant="body1">
                        Upgrading of instruments & Control system of pure Water
                        plant (E+H CPS11/-CPM253 /SIEMENS S7-1217C)
                        <Typography>Zahravi Pharma.Co.(TABRIZ-IRAN)</Typography>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ fontFamily: "roboto" }}
          >
            Chemical
          </AccordionSummary>
          <AccordionDetails>
            <Grid container>
              <Grid xs={12} sm={6} md={6} lg={6} xl={6}>
                <Card sx={{ maxWidth: 345, m: 1 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image={uniliver}
                      alt="UNILIVER pic"
                    />
                    <CardContent>
                      <Typography variant="body1">
                        Control software & Monitoring system of Powder detergent
                        & Liquid detergent plants(SIEMENS- PCS7)
                        <Typography>Uniliver(QAZVIN-IRAN)</Typography>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{ fontFamily: "roboto" }}
          >
            Oil & Gas
          </AccordionSummary>
          <AccordionDetails>
            <Grid container>
              <Grid xs={12} sm={6} md={4} lg={4} xl={4}>
                <Card sx={{ maxWidth: 345, m: 1 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image={polynar}
                      alt="ADY Pic"
                    />
                    <CardContent>
                      <Typography variant="body1">
                        Monitoring &Control system for Extruder unit.
                        (S5/115CPU)
                        <Typography>Polynar.Co.(TABRIZ-IRAN)</Typography>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              <Grid xs={12} sm={6} md={4} lg={4} xl={4}>
                <Card sx={{ maxWidth: 345, m: 1 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image={ady}
                      alt="ADY Pic"
                    />
                    <CardContent>
                      <Typography variant="body1">
                        Control & Monitoring system & instrument of Butimen
                        plant(SIEMENS S7-315/E+H)
                        <Typography>
                          Fakhr Azarbaijan Co.(JOLFA-IRAN)
                        </Typography>
                        <Typography>Ady Co.(SOFIAN-IRAN)</Typography>
                        <Typography>
                          Birjand Butimen Co.(BIRJAND-IRAN)
                        </Typography>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
              <Grid xs={12} sm={6} md={4} lg={4} xl={4}>
                <Card sx={{ maxWidth: 345, m: 1 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="140"
                      image={kosar}
                      alt="KOSAR Pic"
                    />
                    <CardContent>
                      <Typography variant="body1">
                        Designing , Product & Commissioning of instrument
                        Control & Monitoring system of Gas Condensate
                        Distillation plant(SIEMENS S7-1500/PCS7)
                        <Typography>
                          Petro Palayesh Kosar(AJABSHIR-IRAN)
                        </Typography>
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
};
export default Field;
